import script from "./DetailPublish.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailPublish.vue?vue&type=script&setup=true&lang=js"

import "./DetailPublish.vue?vue&type=style&index=0&id=8bdfd1e0&lang=scss"

const __exports__ = script;

export default __exports__